/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Print_Btn_TitleInputs */

const vi_lot_label_print_btn_title = /** @type {(inputs: Lot_Label_Print_Btn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In tem A7`)
};

/**

* @param {Lot_Label_Print_Btn_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_print_btn_title = /** @type {((inputs?: Lot_Label_Print_Btn_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Print_Btn_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_print_btn_title(inputs)
});